import React, { Suspense } from 'react';
import Card from '../../components/card';
import { Tabs, TabsProps } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { queryProduct } from '../../adapters/product';
import { IProduct } from '../../interfaces/product';
import ProductInfo from './components/product-info';
import BreadcrumbComponent from '../../components/breadcrumb';
import { useQuery } from '@tanstack/react-query';
import ProductStock from './components/product-stock';

const ProductDetail = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { data: product, refetch } = useQuery<IProduct, Error>({
    queryKey: ['get-product', id],
    queryFn: async () => await queryProduct(Number(id)),
  });

  const items: TabsProps['items'] = [
    {
      key: 'product-info',
      label: 'ข้อมูลสินค้า',
      children: (
        <Suspense>
          {product && (
            <ProductInfo data={product} onRefresh={() => refetch()} />
          )}
        </Suspense>
      ),
    },
    {
      key: 'stock',
      label: 'สต็อก',
      children: (
        <Suspense>{product && <ProductStock data={product} />}</Suspense>
      ),
    },
  ];

  return (
    <Card>
      <BreadcrumbComponent
        items={[
          {
            title: (
              <a href="#" onClick={() => navigate(`/product`)}>
                สินค้า
              </a>
            ),
          },
          {
            title: `${product?.name || ''}`,
          },
        ]}
      />
      <div className="flex flex-col gap-4">
        <Tabs
          defaultActiveKey="1"
          items={items}
          className="w-full"
          rootClassName="font-medium"
        />
      </div>
    </Card>
  );
};

export default ProductDetail;
